import { render, staticRenderFns } from "./AddictiveStuffClientHabitsAdd.vue?vue&type=template&id=3ebacb6c&scoped=true&"
import script from "./AddictiveStuffClientHabitsAdd.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientHabitsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebacb6c",
  null
  
)

export default component.exports